import { Box } from '@mui/material';

export const Tag = ({ label = 'beta' }: { label?: string }) => {
  return (
    <Box
      sx={{
        backgroundColor: label === 'beta' ? 'gx.actionBarButtonTile' : 'primary.main',
        fontSize: '8px',
        textTransform: 'uppercase',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: 1,
        px: '4px',
        minWidth: '36px',
        letterSpacing: '0.16px',
        height: '12px'
      }}
    >
      <span>{label}</span>
    </Box>
  );
};
